import { Permission, permissionsClient } from 'api/planning';
import { api } from '../api';

export const permissionsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getPermissions: builder.query<
      Permission[],
      {
        organisationId: number | undefined;
        countryId: number | undefined;
        centreId: number | undefined;
        locationId: number | undefined;
      }
    >({
      query: ({
        organisationId: _organisationId,
        countryId: _countryId,
        centreId: _centreId,
        locationId: _locationId,
      }) => permissionsClient.getPermissions(),
    }),
  }),
});

export const { useGetPermissionsQuery } = permissionsApi;
